module.exports = __webpack_public_path__ + "static/media/module.99c43874.png";